import { Input, InputGroup, InputLeftAddon, InputRightAddon } from "@chakra-ui/react";
import * as React from "react";

// Read-only preview rendering of a questionnaire answer — styled as a real,
// disabled data-entry field (same size/spacing/border as FormInput) rather
// than a plain "Answer: text" label, so preview mode reads as a filled-in
// form instead of a report. `prefix` (e.g. "£", "%") renders as a left
// addon, `suffix` (e.g. "tCO2e", "kg") as a right addon — either way the
// unit sits in the field's grey addon area rather than as a separate label.
function AnswerField({ answerText, prefix, suffix }) {
  const isNumber = answerText !== null && answerText !== "" && !isNaN(answerText);
  const value = isNumber
    ? (+answerText).toLocaleString("en-GB", { maximumFractionDigits: 4 })
    : answerText ?? "";

  const inputProps = {
    isDisabled: true,
    value,
    fontSize: "sm",
    backgroundColor: "white",
    borderColor: "gray.200",
    color: "gray.700",
    marginBlockStart: 1,
    maxInlineSize: { base: "full", lg: "xs" },
    _disabled: { opacity: 1, cursor: "default" },
  };

  if ((prefix && prefix !== "") || (suffix && suffix !== "")) {
    return (
      <InputGroup maxInlineSize={{ base: "full", lg: "xs" }} marginBlockStart={1}>
        {prefix && prefix !== "" && (
          <InputLeftAddon fontWeight="semibold" borderColor="gray.200" children={prefix} />
        )}
        <Input {...inputProps} marginBlockStart={0} maxInlineSize="none" />
        {suffix && suffix !== "" && (
          <InputRightAddon fontWeight="semibold" borderColor="gray.200" children={suffix} />
        )}
      </InputGroup>
    );
  }

  return <Input {...inputProps} />;
}

export default AnswerField;
